import { AccommodationStatus } from '@zeus/index'

/** État d'une demande d'aménagement (#327), partagé par l'admin et l'apprenant. */
export const ACCOMMODATION_STATUS_KEYS: Record<AccommodationStatus, string> = {
  [AccommodationStatus.PENDING]: 'accommodations.status.pending',
  [AccommodationStatus.HANDLED]: 'accommodations.status.handled',
}

export const ACCOMMODATION_STATUS_VARIANTS = {
  [AccommodationStatus.PENDING]: 'warningSubtle',
  [AccommodationStatus.HANDLED]: 'successSubtle',
} as const satisfies Record<AccommodationStatus, string>
